import React, { useEffect, useState } from "react";
import AppInfo from "./AppInfo";

function WorkspacePage({ asHomePage /*, user, isUserLoading*/ }) {
    const [typedText, setTypedText] = useState("");
    const [isTypingComplete, setIsTypingComplete] = useState(false);
    const [isGreenColor, setIsGreenColor] = useState(true);

    const fullText = "We're Launching Soon!";
    const beforeSoon = "We're Launching ";

    useEffect(() => {
        window.scrollTo(0, 0);

        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
    }, []);

    useEffect(() => {
        const runAnimation = async () => {
            setTypedText("");
            setIsTypingComplete(false);
            setIsGreenColor(true);

            for (let i = 0; i <= fullText.length; i++) {
                await new Promise((resolve) => setTimeout(resolve, 100));
                setTypedText(fullText.slice(0, i));
            }

            setIsTypingComplete(true);

            for (let i = 0; i < 5; i++) {
                await new Promise((resolve) => setTimeout(resolve, 500));
                setIsGreenColor(false);
                await new Promise((resolve) => setTimeout(resolve, 500));
                setIsGreenColor(true);
            }

            await new Promise((resolve) => setTimeout(resolve, 1000));
        };

        runAnimation();

        const intervalId = setInterval(
            runAnimation,
            fullText.length * 100 + 5 * 1000 + 1000
        );

        return () => clearInterval(intervalId);
    }, []);

    const homePageStuff = asHomePage;

    return (
        <div className="flex flex-col items-center justify-center">
            <div className="goatscrape-page-root flex flex-col items-center justify-center">
                <div className="h-full w-full flex flex-col items-center justify-center gap-5 mt-[-100px]">
                    {homePageStuff && (
                        <div className="w-[700px] mb-4">
                            <AppInfo />
                        </div>
                    )}
                    <div
                        className={`w-full ${
                            homePageStuff ? "auto" : "h-full"
                        }`}
                    >
                        <h1 className="w-full text-center text-gray-700">
                            <span
                                style={{
                                    fontSize: "30px",
                                    lineHeight: "30px",
                                }}
                            >
                                &nbsp;
                                {typedText.startsWith(beforeSoon) &&
                                typedText.length > beforeSoon.length ? (
                                    <>
                                        {beforeSoon}
                                        <span
                                            className={`transition-colors duration-500 ${
                                                isTypingComplete && isGreenColor
                                                    ? "font-bold text-[var(--goat-theme-green-1)]"
                                                    : "text-gray-700"
                                            }`}
                                        >
                                            {typedText.slice(beforeSoon.length)}
                                        </span>
                                    </>
                                ) : (
                                    typedText
                                )}
                                &nbsp;
                            </span>
                        </h1>
                        <div className="w-full flex flex-col items-center justify-center mt-6">
                            <div className="w-full max-w-md text-sm">
                                <div className="flex justify-center">
                                    <a
                                        href="https://forms.gle/vNyZyxoP6bvahXUx9"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-white font-semibold border border-[var(--goat-theme-green-1)] bg-[var(--goat-theme-green-1)] px-4 py-2  cursor-pointer rounded-[4px] hover:opacity-90 transition-opacity hover:no-underline"
                                    >
                                        Sign Up for the Beta
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WorkspacePage;
